// @flow

import * as R from 'ramda';

import { HttpService } from '~/services';
import { renameKeys } from '~/helpers';

export const resolvers = {
  Query: {
    consumptionPlatformsList: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      // $FlowIssue
      __, // eslint-disable-line no-unused-vars
      { cache }: ApolloCache,
    ): Promise<ConsumptionPlatformsListItem[]> => {
      // Get list of platforms
      const {
        data: { ConsumptionPlatformDetails },
      } = await HttpService.client.get(
        '/Information/GetConsumptionPlatformList',
      );

      const consumptionPlatformsList: ConsumptionPlatformsListItem[] = R.map(
        R.pipe(
          renameKeys({
            PlatformId: 'id',
            PlatformName: 'name',
          }),
          R.assoc('__typename', 'ConsumptionPlatformsListItem'),
        ),
        ConsumptionPlatformDetails,
      );

      cache.writeData({
        data: { consumptionPlatformsList },
      });

      return consumptionPlatformsList;
    },
    generationsList: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      // $FlowIssue
      __, // eslint-disable-line no-unused-vars
      { cache }: ApolloCache,
    ): Promise<GenerationsListItem[]> => {
      const {
        data: { CitizenGenerations },
      } = await HttpService.client.get(
        '/MyWealth/Consumption/GetCitizenGenerationValues',
      );

      const generationsList: GenerationsListItem[] = R.map(
        R.pipe(
          renameKeys({
            Name: 'name',
            Value: 'value',
          }),
          R.assoc('__typename', 'GenerationsListItem'),
        ),
        CitizenGenerations,
      );

      cache.writeData({
        data: { generationsList },
      });

      return generationsList;
    },
    voucherSalesTypeList: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      // $FlowIssue
      __, // eslint-disable-line no-unused-vars
      { cache }: ApolloCache,
    ) => {
      // Get list of platforms
      const {
        data: { SalesType },
      } = await HttpService.client.get(
        '/MyWealth/DepositReward/GetVoucherSalesType',
      );

      const voucherSalesTypeList = R.map(
        R.pipe(
          renameKeys({
            Type: 'type',
            Value: 'value',
          }),
          R.assoc('__typename', 'VoucherSalesTypeListItem'),
        ),
        SalesType,
      );

      cache.writeData({
        data: { voucherSalesTypeList },
      });

      return voucherSalesTypeList;
    },
  },
};
